const hideMembershipModule = () => {
  const module = document.querySelector('[data-membership-module]');
  module && module.classList.add('hidden')
};

const handleMembershipAdd = (e) => {
  e.preventDefault();
  if (typeof inveterate === 'undefined') return;
  const variantId = inveterate.properties.product.variants[0].id;
  const planId = inveterate.properties.product.variants[0].selling_plan_allocations[0].selling_plan_id;
  const data = {
    items: [{
      id: variantId,
      quantity: 1,
      selling_plan: planId,
      properties: {
        _inveterate_subscription: true
      },
    }]
  };

  fetch('/cart/add.js', {
    body: JSON.stringify(data),
    headers: {
      'Content-Type': 'application/json',
    },
    method: 'POST',
  }).then(res => res.json()).then(items => {
    if (typeof updateCart === 'function') {
      updateCart()
      hideMembershipModule();
    } else {
      window.location.reload();
    }
  });
}

document.addEventListener('DOMContentLoaded', () => {
  const joinButtons = [...document.querySelectorAll('[data-btn-join-membership]')];
  joinButtons.forEach((btn) => {
    btn.addEventListener('click', (e) => handleMembershipAdd(e))
  })
})
